import React, { useRef, createContext } from "react";
export const GlobalRefContext = createContext(undefined);

export const GlobalRefProvider = ({ children }) => {
  const activeEdgeCollectionRef = useRef([]);
  const auditTrail = useRef([]);
  const calculatedPositionsRef = useRef({});
  const dragNode = useRef(null);
  const dragNodeParent = useRef(null);
  const edgeCollectionRef = useRef([]);
  const focusRef = useRef(null);
  const handleRef = useRef(null);
  const ignoreNodeChange = useRef(false);
  const keyEdgeCollectionRef = useRef({});
  const keyHandleRef = useRef({});
  const keyNodeCollectionRef = useRef({});
  const lastLayoutIdRef = useRef(null);
  const layoutIdRef = useRef(null);
  const menuRef = useRef(60); // menu height
  const nodeCollectionRef = useRef([]);
  const nodeOffsetsRef = useRef({ x: 0, y: 0 });
  const nodeOffsetsHistoryRef = useRef({});
  const nodesWithoutSources = useRef({});
  const placeholderPositions = useRef({});
  const positionRef = useRef(null);
  const questionsWithoutNo = useRef({});
  const questionsWithoutYes = useRef({});
  const selectRef = useRef(null);
  const selectPersistedRef = useRef({});
  const selectedRef = useRef({});
  const startRef = useRef(null);

  const refs = {
    activeEdgeCollectionRef,
    auditTrail,
    calculatedPositionsRef,
    dragNode,
    dragNodeParent,
    edgeCollectionRef,
    focusRef, //Node ID: focused node
    handleRef,
    ignoreNodeChange,
    keyEdgeCollectionRef,
    keyHandleRef,
    keyNodeCollectionRef,
    lastLayoutIdRef,
    layoutIdRef,
    menuRef,
    nodeCollectionRef,
    nodeOffsetsRef,
    nodeOffsetsHistoryRef,
    nodesWithoutSources,
    placeholderPositions,
    positionRef,
    questionsWithoutNo,
    questionsWithoutYes,
    selectRef, //Node: last actioned select type node
    selectPersistedRef,
    selectedRef,
    startRef, //Node: first node in new collection
  };

  return refs ? (
    <GlobalRefContext.Provider value={refs}>
      {children}
    </GlobalRefContext.Provider>
  ) : null;
};
